const CapitalFirstLetter = (text) => {
    return text && text.charAt(0).toUpperCase() + text.slice(1)
}

export default CapitalFirstLetter;